var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('v-chip',{class:_vm.float,attrs:{"outlined":"","color":"primary"}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(" mdi-star-outline ")]),_vm._v("Advanced")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }